import { PaginationProps, SortDirection } from '@touche-lts/panel-ui/dist'
import {
  StatisticsTableSearchProps,
  StatisticsTableSortProps
} from './statistics-table-base.types'

export const initialStatisticsTablePaginationProps: PaginationProps<StatisticsTableSortProps> = {
  page: 0,
  size: window.innerWidth >= 1920 ? 10 : 6,
  sortDirection: SortDirection.ASC,
  sortProp: StatisticsTableSortProps.ACTIVE_SKUS,
  totalElements: 0,
  totalPages: 0
}

export const initialStatisticsTableSearchProps: StatisticsTableSearchProps = {
  id: undefined,
  productName: undefined,
  storeName: undefined,
  activeSkusMin: undefined,
  activeSkusMax: undefined,
  stockMin: undefined,
  stockMax: undefined,
  soldMin: undefined,
  soldMax: undefined,
  minRevenue: undefined,
  maxRevenue: undefined,
  addedOnPeriod: undefined,
  storeIds: undefined,
  productCountMax: undefined,
  productCountMin: undefined
}

export const statisticsNeedTimeoutProps: Array<keyof StatisticsTableSearchProps> = [
]

/** Unwraps plain arrays or common paged / wrapped API shapes into a list + optional Spring-like page metadata. */
export function normalizeStatisticsListResponse<T = unknown>(
  raw: unknown
): { items: T[]; pageMeta: Record<string, unknown> | null } {
  if (raw == null) return { items: [], pageMeta: null }
  if (Array.isArray(raw)) return { items: raw as T[], pageMeta: null }

  const o = raw as Record<string, unknown>

  if (Array.isArray(o.data)) {
    return { items: o.data as T[], pageMeta: null }
  }

  const fromPageLike = (obj: unknown): { items: T[]; pageMeta: Record<string, unknown> | null } | null => {
    if (!obj || typeof obj !== 'object') return null
    const p = obj as Record<string, unknown>
    let items: T[] | null = null
    if (Array.isArray(p.content)) items = p.content as T[]
    else if (Array.isArray(p.items)) items = p.items as T[]
    else if (Array.isArray(p.results)) items = p.results as T[]
    if (!items) return null
    return { items, pageMeta: extractPageMeta(p) }
  }

  const direct = fromPageLike(o)
  if (direct) return direct

  if (o.data && typeof o.data === 'object') {
    const nested = fromPageLike(o.data)
    if (nested) return nested
  }

  return { items: [], pageMeta: null }
}

function extractPageMeta(obj: Record<string, unknown>): Record<string, unknown> | null {
  const hasPaging =
    obj.totalElements != null ||
    obj.totalPages != null ||
    (Array.isArray(obj.content) && (obj.size != null || obj.number != null || obj.page != null))
  if (!hasPaging) return null
  const contentLen = Array.isArray(obj.content) ? obj.content.length : 0
  const totalElements = (obj.totalElements as number) ?? contentLen
  const size = (obj.size as number) ?? 0
  return {
    number: (obj.number as number) ?? (obj.page as number) ?? 0,
    size,
    totalElements,
    totalPages:
      (obj.totalPages as number) ??
      (size > 0 && totalElements > 0 ? Math.max(1, Math.ceil(totalElements / size)) : 1)
  }
}
